module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAMAAAAM9FwAAAAAM1BMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzeCmiAAAAAEHRSTlMApxILA8+b1cjDvrCSioRKV9cllQAAAElJREFUCNdVyEkOACEMA0GHsK/+/2uHSAgNfXIZqylu2haEVa8rBV5Y9LhQPOzJzuyyeecjg9sOjGbLHjNunSmx49cgB57mPOMDpeICD7Uu7WwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/ic_index_down.png
// module id = Nsti
// module chunks = 21